export default class BFilterList
{
	static initialize()
	{
		document.addEventListener("click", event => {
			const head = event.target.closest(".filter-list .item-head");
			if (!head) {
				return;
			}

			const item = head.closest(".item");
			if (!item) {
				return;
			}

			item.classList.toggle("active");
		});
	}
}
